/**
 * ID Generation Utilities
 * 
 * Provides deterministic, unique ID generation for the expense splitter.
 * Following dev guide: stateless helpers, no DOM imports.
 */

/**
 * Generate a unique ID using timestamp + random component
 * Format: timestamp-randomString (e.g., "1704067200000-abc123")
 */
export function generateId(): string {
  const timestamp = Date.now();
  const randomPart = Math.random().toString(36).substring(2, 8);
  return `${timestamp}-${randomPart}`;
}

/**
 * Generate a device ID for conflict resolution
 * Stored in localStorage and reused across sessions
 */
export function getDeviceId(): string {
  const DEVICE_ID_KEY = 'expense-splitter-device-id';
  
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  
  if (!deviceId) {
    deviceId = `device-${generateId()}`;
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  
  return deviceId;
}

/**
 * Generate a group ID with specific prefix
 */
export function generateGroupId(): string {
  return `group-${generateId()}`;
}

/**
 * Generate a participant ID with specific prefix
 */
export function generateParticipantId(): string {
  return `participant-${generateId()}`;
}

/**
 * Generate an expense ID with specific prefix
 */
export function generateExpenseId(): string {
  return `expense-${generateId()}`;
}
